import React, { Component } from "react";
import ReactGA from "react-ga";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import NewRouteIcon from "@material-ui/icons/Refresh";

import frank from "../../images/ambassadors/frank.jpg";
import goedele from "../../images/ambassadors/goedele.jpg";
import ruben from "../../images/ambassadors/ruben.jpg";
import saartje from "../../images/ambassadors/saartje.png";
import Badge from "../atoms/Badge";
import RoutesOverview from "../atoms/RoutesOverview";
import RouteApi from "./RouteApi";
import BikeNodeNav from "../../NewRoute/components/BikeNodeNav";

const styles = {
  root: {
    marginBottom: "56px"
  },
  title: {
    textAlign: "center"
  },
  avatars: { display: "flex", height: "90px" },
  avatar: { flex: "0 0 auto", height: "56px", width: "56px", margin: "0 5px" },
  allRoutes: {
    // margin: 10
  },
  buttons: {
    margin: 8
  },
  downloadGpxButton: {
    marginRight: "1em",
    fontSize: 20
  },
  // newRouteButton: {
  //   margin: "1em 0 1em 0"
  // },
  center: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  loader: {
    marginTop: "40vh",
    textAlign: "center"
  }
};

function flatten(object) {
  let result = [];
  Object.keys(object).forEach(ambassador => {
    const name = object[ambassador].name;
    Object.keys(object[ambassador].routes).forEach(routeKey => {
      const route = object[ambassador].routes[routeKey];
      result.push({
        ambassadorKey: ambassador,
        routeKey,
        ambassador: name,
        ...route
      });
    });
  });
  return result;
}

function downloadGpx(selectedRoute) {
  window.open(
    // `http://localhost:5000/gpx/${selectedRoute}`,
    `https://conamo-api.herokuapp.com/gpx/${selectedRoute}`,
    "_blank",
    "noopener noreferrer"
  );
}

function AmbassadorsWrapper(props) {
  const {
    classes,
    selectedAmbassador,
    routes,
    onAvatarClick,
    onSelectRoute,
    reset,
    geojson
  } = props;
  let selectedRoute = props.selectedRoute;
  if (selectedRoute === undefined) {
    selectedRoute = localStorage.getItem("selectedRoute");
  }

  let filterRoutes;
  if (selectedAmbassador === "all") {
    filterRoutes = flatten(routes);
  } else {
    filterRoutes = Object.keys(routes[selectedAmbassador].routes).map(
      routeKey => {
        const value = routes[selectedAmbassador].routes[routeKey];
        return { ambassadorKey: selectedAmbassador, routeKey, ...value };
      }
    );
  }

  if (geojson) {
    return (
      <div className={classes.center}>
        <BikeNodeNav geojson={geojson} type="ambassador" />
        <div className={classes.buttons}>
          <Button
            variant="fab"
            className={classes.downloadGpxButton}
            onClick={() => {
              downloadGpx(selectedRoute);
            }}
          >
            GPX
          </Button>
          <Button
            variant="fab"
            className={classes.newRouteButton}
            onClick={reset}
          >
            <NewRouteIcon />
          </Button>
        </div>
      </div>
    );
  }

  if (selectedRoute) {
    const parameters = {
      type: "ambassador",
      route: selectedRoute
    };

    return (
      <RouteApi
        parameters={parameters}
        render={({ isLoading, data, error, errorMessage }) => {
          if (error) {
            return (
              <div className={classes.center}>
                <div>{errorMessage}</div>
                <Button
                  variant="raised"
                  className={classes.newRouteButton}
                  onClick={reset}
                >
                  Kies andere route
                </Button>
              </div>
            );
          }
          return isLoading ? (
            <div className={classes.loader}>
              <CircularProgress size={80} thickness={7} />
            </div>
          ) : (
            <div className={classes.center}>
              <BikeNodeNav geojson={data} type="ambassador" />
              <div className={classes.buttons}>
                {" "}
                <Button
                  variant="fab"
                  className={classes.downloadGpxButton}
                  onClick={() => {
                    downloadGpx(selectedRoute);
                  }}
                >
                  GPX
                </Button>
                <Button
                  variant="fab"
                  className={classes.newRouteButton}
                  onClick={reset}
                >
                  <NewRouteIcon />
                </Button>
              </div>
            </div>
          );
        }}
      />
    );
  }
  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Ambassadeurs</h1>
      <div className={classes.avatars}>
        <div className={classes.avatar}>
          <Button
            variant="fab"
            aria-label="add"
            className={classes.allRoutes}
            onClick={() => onAvatarClick("all")}
          >
            <AllInclusiveIcon />
          </Button>
        </div>
        <div className={classes.avatar}>
          <Badge
            image={frank}
            name="Frank"
            value="frankdeboosere"
            onClick={onAvatarClick}
          />
        </div>
        <div className={classes.avatar}>
          <Badge
            image={goedele}
            name="Goedele"
            value="goedelewachters"
            onClick={onAvatarClick}
          />
        </div>
        <div className={classes.avatar}>
          <Badge
            image={saartje}
            name="Saartje"
            value="saartjevandendriessche"
            onClick={onAvatarClick}
          />
        </div>
        <div className={classes.avatar}>
          <Badge
            image={ruben}
            name="Ruben"
            value="rubenvangucht"
            onClick={onAvatarClick}
          />
        </div>
      </div>
      <div>
        <RoutesOverview routes={filterRoutes} onSelectRoute={onSelectRoute} />
      </div>
    </div>
  );
}

AmbassadorsWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  routes: PropTypes.object.isRequired,
  selectedAmbassador: PropTypes.string.isRequired,
  onAvatarClick: PropTypes.func.isRequired,
  onSelectRoute: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  selectedRoute: PropTypes.string,
  geojson: PropTypes.object
};

class Ambassadors extends Component {
  state = {
    selectedAmbassador: "all",
    showModal: false
  };

  componentDidMount = () => {
    try {
      const geojson = JSON.parse(localStorage.getItem("ambassadorgeojson"));
      if (geojson.features === undefined) {
        throw new Error("invalid geojson stored");
      }
      if (geojson) {
        this.setState({ geojson });
      }
    } catch (_) {
      localStorage.removeItem("ambassadorgeojson");
    }
  };

  onAvatarClick = selectedAmbassador => {
    ReactGA.event({
      category: "Route",
      action: "Filter ambassador",
      label: selectedAmbassador
    });
    this.setState({ selectedAmbassador });
  };

  onSelectRoute = selectedRoute => {
    const { selectedAmbassador } = this.state;
    ReactGA.event({
      category: "Route",
      action: "Selected route",
      label: selectedAmbassador + "/" + selectedRoute
    });
    this.setState({ selectedRoute });
    localStorage.setItem("selectedRoute", selectedRoute);
  };

  reset = () => {
    this.setState({ showModal: true });
  };

  handleClose = shouldReset => {
    ReactGA.event({
      category: "Route",
      action: "Generate new route"
    });
    if (shouldReset === true) {
      this.setState({ geojson: null, selectedRoute: null });
      localStorage.removeItem("ambassadorgeojson");
    }
    this.setState({ showModal: false });
  };

  render() {
    const { classes } = this.props;
    const {
      selectedAmbassador,
      selectedRoute,
      showModal,
      geojson
    } = this.state;

    const parameters = {
      type: "ambassadorlist"
    };

    return (
      <div>
        <RouteApi
          parameters={parameters}
          render={({ isLoading, data, error, errorMessage }) => {
            if (error) {
              return (
                <div className={classes.center}>
                  <div>{errorMessage}</div>
                  <Button
                    variant="raised"
                    className={classes.newRouteButton}
                    onClick={this.reset}
                  >
                    Kies andere route
                  </Button>
                </div>
              );
            }
            return isLoading ? (
              <div className={classes.loader}>
                <CircularProgress size={80} thickness={7} />
              </div>
            ) : (
              <AmbassadorsWrapper
                classes={classes}
                selectedAmbassador={selectedAmbassador}
                selectedRoute={selectedRoute}
                routes={data}
                onAvatarClick={this.onAvatarClick}
                onSelectRoute={this.onSelectRoute}
                reset={this.reset}
                geojson={geojson}
              />
            );
          }}
        />
        <Dialog
          open={showModal}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Andere route</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ben je zeker dat je een andere route wilt kiezen?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Nee
            </Button>
            <Button
              onClick={() => {
                this.handleClose(true);
              }}
              color="primary"
            >
              Ja
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Ambassadors.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Ambassadors);



// WEBPACK FOOTER //
// ./src/Ambassadors/components/Ambassadors.js